module.exports = __webpack_public_path__ + "static/media/bg-login.78d76c25.jpg";